mutation ImportLibraryData($campaignId: ID!, $rows: [InputImportRow!]!) {
    importLibraryData(campaignId: $campaignId, rows: $rows) {
        _id
        name
        status
        message
    }
}
